module.exports = __webpack_public_path__ + "static/media/location1.ac20ba39.gif";